<template>
  <ModalHelper v-bind="{ ...props, mobileOnly: isMobileOnly }" v-model="fieldValue" @close="closeModal" @blocked="emit('blocked')">
    <slot />
  </ModalHelper>  
</template>

<script setup>
  const emit = defineEmits(['update:modelValue', 'close', 'blocked'])
  const props = defineProps({
    modelValue: {},
    class: {},
    medium: {
      default: false
    },
    focusInput: {
      default: false
    },
    mobileOnly: {
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    }
  })

  const { fieldValue } = useFormField(props, emit)
  const isMobileOnly = computed(() => props.mobileOnly !== false)

  function closeModal() {
    emit('close')
    document.documentElement.classList.remove('isModalOpen')
    setTimeout(() => {
      document.documentElement.classList.remove('isOverflow')
    }, 300)
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_modal.scss');
</style>